/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    18/06/2018
 */
import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'lemsar-image-uploader',
    template: `
        <div>
            <div class="upload-control">
                <div class="img-preview">
                    <a class="img-close" *ngIf="file" (click)="setFile(null)">
                        <i class="fa fa-window-close"></i>
                    </a>
                    <i class="fa fa-image" (click)="select()" *ngIf="!file && !getSource()"></i>
                    <img #image *ngIf="file || getSource()" [src]="getSource()"/>
                </div>
                <div class="btn-upload-container">
                    <label #btnUploader [ngClass]="['btn btn-medium btn-block', buttonClass]">
                        <input #inputFile accept="image/*" (change)="selected($event)" type="file"/>
                        <i class="fa fa-image v-align-middle"></i>
                        {{ buttonText }}
                    </label>
                </div>
            </div>
            <div class="upload-info">
                <ng-content></ng-content>
            </div>
        </div>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ImageUploaderComponent),
            multi: true,
        },
    ],
})
export class ImageUploaderComponent implements ControlValueAccessor {
    @Input() public buttonText: string = 'Pilih Gambar';

    @Input() public buttonClass: string = 'btn-success';

    @Input() public file: File;

    @Input() public source: string;

    @Input() public defaultSource: string;

    @Output() public changed: EventEmitter<File> = new EventEmitter<File>();

    @ViewChild('inputFile') private inputFile: ElementRef;

    @ViewChild('image') private preview: ElementRef;

    @ViewChild('btnUploader') private btnUploader: ElementRef;

    public propagateChange = (file: File) => {};

    public reader: FileReader;

    public constructor() {
        this.reader = new FileReader();
        this.reader.addEventListener('load', this.readerOnLoad.bind(this));
        if (this.file) {
            this.setFile(this.file);
        }
    }

    public writeValue(file: File): void {
        this.setFile(file);
    }

    public registerOnChange(fn: (file: File) => void): void {
        this.propagateChange = fn;
    }

    public registerOnTouched(fn: any): void {}

    public select(): void {
        this.btnUploader.nativeElement.click();
    }

    public readerOnLoad(e: any): void {
        this.preview.nativeElement.src = e.target.result;
    }

    public selected(event: any): void {
        this.setFile(event.target.files.length ? event.target.files[0] : null);
    }

    public setFile(file: File) {
        if (file) {
            this.file = file;
            this.reader.readAsDataURL(this.file);
        } else {
            if (this.source || this.defaultSource) {
                this.preview.nativeElement.src = this.getSource();
            } else {
                if (this.preview) {
                    this.preview.nativeElement.removeAttribute('src');
                }
            }

            this.inputFile.nativeElement.value = null;
            // this.file = null;
        }

        this.propagateChange(this.file);
        this.changed.emit(this.file);
    }

    public getSource(): string {
        if (this.source) {
            return this.source;
        }

        return this.defaultSource;
    }
}



// WEBPACK FOOTER //
// ./src/shared/module/uploader/image-uploader.component.ts